import React, { Component } from 'react'
import { Container } from '../global/grid/grid'
import SurveyorSvg from '../../static/svgs/surveyor.svg'

import { RepeatingElementsWrapper } from './styled-components'

import colors from '../../vars/colors'

class RepeatingElements extends Component {
  constructor (props) {
    super(props)
    this.state = {
      bodyHeight: 0,
      stamps: []
    }
    this.stamps = null
    this.shuffle = this.shuffle.bind(this)
  }
  componentDidMount () {
    const { stamps } = this.props
    const bodyHeight = this.mainContainer.offsetHeight
    this.setState({
      bodyHeight: bodyHeight,
      stamps: stamps
    })
  }
  shuffle (a) {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]]
    }
    return a
  }
  createSurveyorBackground () {
    let surveyorBackgrounds = []
    let surveyorBackgroundsLeft = true
    for (let i = 0; i < this.state.bodyHeight - 1250; i += 1250) {
      const background = (
        <div key={i} style={{
          position: 'absolute',
          top: `${i + 50}px`,
          left: surveyorBackgroundsLeft ? 'auto' : '-500px',
          right: surveyorBackgroundsLeft ? '-500px' : 'auto',
          textAlign: surveyorBackgroundsLeft ? 'left' : 'right',
          width: '100%'
        }}
        >
          <SurveyorSvg style={{
            transform: `rotate(${Math.random() * 360}deg)`
          }} />
        </div>)
      surveyorBackgrounds.push(background)
      surveyorBackgroundsLeft = !surveyorBackgroundsLeft
    }
    return surveyorBackgrounds
  }
  createStamps (stamps) {
    let stampLoop = 0
    let stampsArray = []
    let stampsLeft = true
    let stampRed = true
    let stamp = ''
    stamps = this.shuffle(stamps)
    for (let i = 0; i < this.state.bodyHeight - 1000; i += (550 + (Math.random() * 400))) {
      if (stamps[stampLoop % stamps.length] === 'stripes') {
        const colorRandomizer = Math.random()
        stamp = (
          <div key={i} style={{
            position: 'absolute',
            top: `${i + 1000}px`,
            left: stampsLeft ? '10px' : 'auto',
            right: stampsLeft ? 'auto' : '10px',
            textAlign: stampsLeft ? 'left' : 'right',
            width: '100%'
          }}
          >
            <div style={{
              display: 'inline-block',
              width: '20px',
              height: '170px',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                width: '20px',
                height: '197px',
                textAlign: 'left',
                background: `repeating-linear-gradient(45deg, ${(colorRandomizer > 0.5) ? colors['lipstick'] : colors['peacock-blue']}, ${(colorRandomizer > 0.5) ? colors['lipstick'] : colors['peacock-blue']} 20px, rgba(255, 255, 255, 0.5) 20px, rgba(255, 255, 255, 0.5) 40px)`
              }} />
            </div>
          </div>
        )
      } else {
        const stampPhrase = stamps[stampLoop % stamps.length].map((element, index) => {
          return <span key={index}>{element}<br /></span>
        })
        stamp = (
          <div key={i} style={{
            position: 'absolute',
            top: `${i + 1000}px`,
            left: stampsLeft ? '10px' : 'auto',
            right: stampsLeft ? 'auto' : '50px',
            textAlign: stampsLeft ? 'left' : 'right',
            width: '100%'
          }}
          >
            <div style={{
              transform: 'rotate(-90deg)',
              transformOrigin: 'center center',
              display: 'inline-block',
              width: '10px',
              height: '10px',
              position: 'relative',
              overflow: 'visible'
            }}>
              <div style={{ width: '1000px', textAlign: 'left' }}>
                <div style={{
                  border: `solid 4px ${stampRed ? colors['lipstick'] : colors['peacock-blue']}`,
                  color: `${stampRed ? colors['lipstick'] : colors['peacock-blue']}`,
                  display: 'inline-block',
                  textAlign: 'center',
                  fontFamily: '"OneDotExt", sans-serif',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  padding: '3px 2px',
                  marginRight: '10px'
                }}
                >
                  { stampPhrase }
                </div>
                <div style={{
                  border: `solid 4px ${stampRed ? colors['lipstick'] : colors['peacock-blue']}`,
                  color: `${stampRed ? colors['lipstick'] : colors['peacock-blue']}`,
                  display: 'inline-block',
                  textAlign: 'center',
                  fontFamily: '"OneDotExt", sans-serif',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  padding: '3px 2px',
                  marginRight: '10px'
                }}
                >
                  { stampPhrase }
                </div>
                <div style={{
                  border: `solid 4px ${stampRed ? colors['lipstick'] : colors['peacock-blue']}`,
                  color: `${stampRed ? colors['lipstick'] : colors['peacock-blue']}`,
                  display: 'inline-block',
                  textAlign: 'center',
                  fontFamily: '"OneDotExt", sans-serif',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  padding: '3px 2px',
                  marginRight: '10px'
                }}
                >
                  { stampPhrase }
                </div>
              </div>
            </div>
          </div>)
      }
      stampsArray.push(stamp)
      stampsLeft = !stampsLeft
      stampRed = !stampRed
      stampLoop++
    }
    return stampsArray
  }
  render () {
    return (
      <div style={{ position: 'absolute', width: '100%', zIndex: '-999', top: 0, left: 0, right: 0, bottom: '-120px', overflow: 'hidden' }} ref={(div) => { this.mainContainer = div }}>
        <Container style={{ position: 'relative' }}>
          <RepeatingElementsWrapper>
            { this.createSurveyorBackground() }
            { this.createStamps(this.state.stamps) }
          </RepeatingElementsWrapper>
        </Container>
      </div>
    )
  }
}

export default RepeatingElements



// WEBPACK FOOTER //
// ./src/components/RepeatingElements/RepeatingElements.js